if (!window.__customCarouselInitialized) {
  class CustomCarousel extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('[data-custom-carousel-container]');
      this.prevButton = this.querySelector('[data-custom-carousel-prev]');
      this.nextButton = this.querySelector('[data-custom-carousel-next]');

      if (!this.container) return;

      const getSlideWidth = () => {
        const firstSlide = this.container.querySelector('li');
        return firstSlide ? firstSlide.offsetWidth : this.container.clientWidth;
      };

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.container.scrollBy({
            left: -getSlideWidth(),
            behavior: 'smooth',
          });
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.container.scrollBy({
            left: getSlideWidth(),
            behavior: 'smooth',
          });
        });
      }
    }
  }

  if (!customElements.get('custom-carousel')) {
    customElements.define('custom-carousel', CustomCarousel);
  }
}
